import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const PESurveysCardState = {
  selectedCards: {},
}

export const PESurveysCardActions = {
  initPeSurveysCard: ({ commit }, index) => {
    commit('setPeSurveysCardLock', { index, lock: true })
    commit('resetPeSurveysSelectedMiniCard')
  },
  peSurveysCardCreate: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      post(`/parties/${party.id}/surveys`, {
        party_id: party.id,
        cards: section.cards,
        contact_id: section.contact_id,
        contact_type: section.contact_type,
      }).
      then(({ data }) => {
        commit('setPeSurveysCardLock', { index, lock: true })
        commit('pePatchParty', {
          surveys: data || [],
        })

        return data
      }).
      catch(handleError)
  },
  peSurveysCardRefresh: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty
    return axiosRequest.
      get(`/parties/${party.id}/surveys/${section.id}`).
      then(({ data }) => {
        commit('setPeSurveysCardLock', { index, lock: true })
        commit('pePatchCharacteristic', {
          characteristic: 'surveys',
          value: data,
        })
      }).
      catch(handleError)
  },
  peSurveysCardUpdate: async ({ commit, getters }, { id, section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      patch(`/parties/${party.id}/surveys/${id}`, {
        party_id: party.id,
        cards: section.cards,
        contact_id: section.contact_id,
        contact_type: section.contact_type,
      }).
      then(({ data }) => {
        commit('setPeSurveysCardLock', { index, lock: true })
        commit('pePatchParty', {
          surveys: data || [],
        })
      }).
      catch(handleError)
  },
  peSurveysCardDelete: async ({ commit, getters }, { id, index }) => {
    const party = getters.peParty

    return axiosRequest.
      delete(`/parties/${party.id}/surveys/${id}`).
      then(({ data }) => {
        commit('setPeSurveysCardLock', { index, lock: true })
        commit('pePatchParty', {
          surveys: data || [],
        })
      }).
      catch(handleError)
  },
  peSurveysCardAddSection: ({ commit }) => {
    commit('setPeSurveysCardLock', { index: 'new', lock: false })
    commit('addPeSurveysCardSection', {
      id: null,
      cards: {},
      contact: null,
      contact_type: null,
    })
  },
  peSurveysCardSelectMiniCard: ({ commit }, payload) => {
    commit('togglePeSurveysSelectedMiniCard', payload)
  },

  peSurveyActivateValidation: ({ commit, dispatch }, section) => {
    commit('peSurveysActivateValidation', section.auth_token)
    return dispatch('surveyPartyLoadSession', section.auth_token)
  },

  peSurveyDeactivateValidation: ({ commit }) => {
    commit('surveyPageSetSession', null)
    commit('peSurveysActivateValidation', null)
  },

  peSurveyNotifyParty: async ({ getters }, section) => {
    const party = getters.peParty
    return axiosRequest.
      post(`/parties/${party.id}/surveys/${section.id}/notify`).
      catch(handleError)
  },

  peSurveyCardUpdateContactName: ({ commit }, payload) => {
    commit('peSurveyCardSetContactName', payload)
  },
  peSurveyCardAcceptCard: ({ commit, dispatch }, { identifier }) => {
    commit('peSurveyCardSetAcceptance', { identifier })
    return dispatch('surveyPartySaveSession')
  },
  peSurveyCardRejectCard: ({ commit, dispatch }, { identifier }) => {
    commit('peSurveyCardSetRejectance', { identifier })
    return dispatch('surveyPartySaveSession')
  },
}

export const PESurveysCardMutations = {
  setPeSurveysCardLock: (state, { index, lock }) => {
    if (!state.partyEdit.partySections.SurveysCard) Vue.set(state.partyEdit.partySections, 'SurveysCard', {})
    Vue.set(state.partyEdit.partySections.SurveysCard, index, lock)
  },
  addPeSurveysCardSection: (state, section) => {
    state.partyEdit.party.surveys.push(section)
  },
  peSurveysCardCreateUndo: state => {
    state.partyEdit.party.surveys.pop()
    Vue.set(state.partyEdit.partySections.SurveysCard, 'new', true)
  },
  togglePeSurveysSelectedMiniCard: (state, { identifier, selected, id }) => {
    const survey = state.partyEdit.party.surveys.find(survey => survey.id === id)
    survey.cards = survey.cards || {}
    Vue.set(survey.cards, identifier, selected)
  },
  resetPeSurveysSelectedMiniCard: state => {
    Vue.set(state.partyEdit.surveys, 'selectedCards', {})
  },
  peSurveysSetSelectedMiniCard: (state, cards) => Vue.set(state.partyEdit.surveys, 'selectedCards', cards),
  peSurveysActivateValidation: (state, session) => {
    state.partyEdit.party_survey_session = session
  },

  peSurveyCardSetContactName: (state, { contactTypeName, section }) => {
    const peParty = state.partyEdit.party
    const survey = peParty.surveys?.find(s => s.id === section.id)

    survey.contact_type_name = contactTypeName
  },

  peSurveyCardSetAcceptance: (state, { identifier }) => {
    const survey = state.survey_session.value.find(s => s.identifier === identifier)
    Vue.set(survey, 'accepted', true)
  },

  peSurveyCardSetRejectance: (state, { identifier }) => {
    const survey = state.survey_session.value.find(s => s.identifier === identifier)
    Vue.set(survey, 'rejected', true)
  },
}

export const PESurveysCardGetters = {
  peSurveysCardLock: state => index => state.partyEdit.partySections.SurveysCard[index],
  peSurveysCardHasNewSection: (_, getters) => !!getters.peParty.surveys?.find(survey => survey.id === null),
  peSurveysMiniCardSelected: state => (identifier, id) => {
    const survey = state.partyEdit.party.surveys.find(survey => survey.id === id)
    return survey.cards ? survey.cards[identifier] : false
  },
  peSurveyMiniCardAllSelected: state => state.partyEdit.surveys.selectedCards,
  peSurveysValidationActive: state => !!state.partyEdit.party_survey_session,
  peSurveyCardAcceptedCard: state => identifier => state.survey_session.value.find(s => s.identifier === identifier)?.accepted,
  peSurveyCardRejectedCard: state => identifier => state.survey_session.value.find(s => s.identifier === identifier)?.rejected,
  peSurveyCardData: state => identifier => state.survey_session?.value.find(s => s.identifier === identifier),
}
